import './cardChrome.css';

/** Shown instead of the TV page on a phone: the phone is the controller. */
export default function PhoneNotice() {
  return (
    <main className="splash phone-notice">
      <div className="brand">LAG<span>KING</span></div>
      <section className="pair-panel">
        <p className="kicker">LAGKING TV</p>
        <h1 className="phone-notice-title">Open this on a big screen</h1>
        <p className="instruction">
          Go to <strong>tv.lagking.com</strong> on a laptop, desktop, or your TV&apos;s web browser.
          Then pair it from the <strong>LagKing</strong> app on this phone: Settings, TV, Add a TV.
        </p>
        <p className="phone-notice-note">Your phone is the controller. The putting view shows on the big screen.</p>
      </section>
    </main>
  );
}
